export const ApiHost = process.env.VUE_APP_ENDPOINT_HOST;

export default {
  api: {
    auth: {
      token: '/api/auth/token/',
      refresh: '/api/auth/refresh/',
    },
    account: {
      me: '/api/account/me/',
      hostCompany: '/api/account/company/',
      changePassword: '/api/account/password/change/',
      forgetPassword: '/api/account/password/forget/',
      resetPassword: '/api/account/password/reset/',
      subAccounts: '/api/account/sub-accounts/',
      subAccount: (pk: number) => `/api/account/sub-accounts/${pk}/`,
      toggleSubAccount: (pk: number) => `/api/account/sub-accounts/${pk}/toggle/`,
      deleteSubAccount: (pk: number) => `/api/account/sub-accounts/${pk}/`,
    },
    notification: {
      notifications: '/api/notifications/',
      notificationDetail: (pk: number) => `/api/notifications/${pk}/`,
      confirm: (pk: number) => `/api/notifications/${pk}/confirm/`,
    },
    attendance: {
      attendance_by_month: (year: string, month: string) => `/api/attendance/${year}/${month}/`,
    },
    order: {
      orders_by_month: (year: string, month: string) => `/api/order/orders/${year}/${month}/`,
      orderDetail: (pk: number) => `/api/order/orders/${pk}/`,
      orderHtml: (pk: number) => `/api/order/orders/${pk}/html/`,
      orderPdf: (pk: number) => `/api/order/orders/${pk}/pdf/`,
      approvalOrder: (pk: number) => `/api/order/orders/${pk}/approval/`,
    },
    request: {
      request_by_month: (year: string, month: string) => `/api/request/requests/${year}/${month}/`,
      requestDetail: (pk: number) => `/api/request/requests/${pk}/`,
      requestHtml: (pk: number) => `/api/request/requests/${pk}/html/`,
      requestPdf: (pk: number) => `/api/request/requests/${pk}/pdf/`,
      approvalRequest: (pk: number) => `/api/request/requests/${pk}/approval/`,
    },
    partner: {
      histories: '/api/partner/histories/',
      todos: '/api/partner/todos/',
      search: '/api/partner/search/',
    },
  }
}
